;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { z } from "zod";
import { CLIENT_INVALIDATION_EVENT_TYPE } from "@/lib/client-invalidation/catalog";

const requiredId = z.string().min(1);

const executionUpdatedSchema = z.object({
	automationId: requiredId,
	executionId: requiredId,
	type: z.literal(CLIENT_INVALIDATION_EVENT_TYPE.executionUpdated),
	workspaceId: requiredId,
});

const visualizationStaleSchema = z.object({
	type: z.literal(CLIENT_INVALIDATION_EVENT_TYPE.visualizationStale),
	workspaceId: requiredId,
});

const agentExecutionUpdatedSchema = z.object({
	agentId: requiredId,
	type: z.literal(CLIENT_INVALIDATION_EVENT_TYPE.agentExecutionUpdated),
	workspaceId: requiredId,
});

const automationStateChangedSchema = z.object({
	type: z.literal(CLIENT_INVALIDATION_EVENT_TYPE.automationStateChanged),
	workspaceId: requiredId,
});

const commentChangedSchema = z.object({
	type: z.literal(CLIENT_INVALIDATION_EVENT_TYPE.commentChanged),
	viewVisualizationId: requiredId,
	workspaceId: requiredId,
});

const notificationChangedSchema = z.object({
	type: z.literal(CLIENT_INVALIDATION_EVENT_TYPE.notificationChanged),
	userId: requiredId.optional(),
	workspaceId: requiredId.optional(),
});

const alertChangedSchema = z.object({
	type: z.literal(CLIENT_INVALIDATION_EVENT_TYPE.alertChanged),
	viewVisualizationGroupId: requiredId.optional(),
	workspaceId: requiredId,
});

const workflowChangedSchema = z.object({
	type: z.literal(CLIENT_INVALIDATION_EVENT_TYPE.workflowChanged),
	viewVisualizationGroupId: requiredId.optional(),
	workspaceId: requiredId,
});

const workspaceMembershipChangedSchema = z.object({
	type: z.literal(CLIENT_INVALIDATION_EVENT_TYPE.workspaceMembershipChanged),
	workspaceId: requiredId,
});

const userSettingsChangedSchema = z.object({
	type: z.literal(CLIENT_INVALIDATION_EVENT_TYPE.userSettingsChanged),
	userId: requiredId,
});

const usageTrackingChangedSchema = z.object({
	organizationId: requiredId,
	type: z.literal(CLIENT_INVALIDATION_EVENT_TYPE.usageTrackingChanged),
});

export const clientInvalidationEventSchema = z
	.discriminatedUnion("type", [
		executionUpdatedSchema,
		visualizationStaleSchema,
		agentExecutionUpdatedSchema,
		automationStateChangedSchema,
		commentChangedSchema,
		notificationChangedSchema,
		alertChangedSchema,
		workflowChangedSchema,
		workspaceMembershipChangedSchema,
		userSettingsChangedSchema,
		usageTrackingChangedSchema,
	])
	.superRefine((event, context) => {
		if (event.type !== CLIENT_INVALIDATION_EVENT_TYPE.notificationChanged) {
			return;
		}

		if (!event.userId && !event.workspaceId) {
			context.addIssue({
				code: z.ZodIssueCode.custom,
				message: "notification.changed requires userId or workspaceId",
				path: ["workspaceId"],
			});
		}
	});

export type ClientInvalidationEvent = z.infer<
	typeof clientInvalidationEventSchema
>;
